import React from 'react'
import colors from '../../../utils/Colors'
import './styles.css'

const style = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const LoadingComponent = ({size = 40, containerStyles = {}, stroke=colors.blue}) => {
    return (
        <div style={{...style, ...containerStyles}}>
            {/* the colour rides on `color` and the circle inherits it: a var()
                in a presentation attribute is not safe across browsers */}
            <svg className="loader" viewBox="25 25 50 50" aria-hidden="true" stroke="currentColor"
                 style={{color: stroke}} width={size} height={size}>
                <circle className="loader-circle" cx="50" cy="50" r="20" fill="none" strokeWidth="4"/>
            </svg>
        </div>
    )
};
export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components-new/ui/LoadingComponent/index.jsx